import TokenDataWidget from './token-data-widget';

const TokenDataWrapperProvider = (props: any) => {
  return <TokenDataWidget {...props} />;
};

export default TokenDataWrapperProvider;
